import React from 'react';
import styled from 'styled-components';
import { TextInput } from '@atoms/Forms/Inputs';
import { Form } from 'react-bootstrap';

type Props = {
    label: string,
    controlId: string,
    badge?: string,
    placeholder?: string,
}

const InputGroup = (props: Props) => {
    const { label, controlId, badge, placeholder } = props;

    return (
        <Form.Group controlId={ controlId }>
            <Form.Label className="d-flex justify-content-between align-items-center">
                <LabelWithStyled>{ label }</LabelWithStyled>
                { badge && <BadgeWithStyled className="badge bg-secondary">{ badge }</BadgeWithStyled> }
            </Form.Label>
            <TextInput placeholder={ placeholder } />
        </Form.Group>
    )
}

const LabelWithStyled = styled.span`
`
const BadgeWithStyled = styled.span`
`

export default InputGroup;